module.exports = __webpack_public_path__ + "static/media/white-logo-with-accents.0e2830a9.png";